import { ChartTheme } from '@nimbus-library/features/charts/models/char-theme.enum';
import { ThemeSetting } from '@nimbus-library/features/user-settings/models/enums/theme-setting.enum';

export namespace CommonThemeActions {
  export class Initialize {
    public static readonly type = '[CommonTheme] Initialize';
  }

  export class SetThemeSetting {
    public static readonly type = '[CommonTheme] Set Theme Setting';
    public constructor(public readonly themeSetting: ThemeSetting) {}
  }

  export class SetTheme {
    public static readonly type = '[CommonTheme] Set Theme';
    public constructor(public readonly theme: ChartTheme) {}
  }
}
